"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createAuthExchange", {
    enumerable: true,
    get: function() {
        return createAuthExchange;
    }
});
var _exchangeAuth = require("@urql/exchange-auth");
var _core = require("@urql/core");
var _jwtDecode = /*#__PURE__*/ _interopRequireDefault(require("jwt-decode"));
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = (void 0) && (void 0).__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var createAuthExchange = function(authCallbacks) {
    return (0, _exchangeAuth.authExchange)({
        addAuthToOperation: function(param) {
            var authState = param.authState, operation = param.operation;
            // the token isn't in the auth state, return the operation without changes
            if (!authState || !authState.token) {
                return operation;
            }
            var fetchOptions = operation.context.fetchOptions;
            return (0, _core.makeOperation)(operation.kind, operation, _objectSpreadProps(_objectSpread({}, operation.context), {
                fetchOptions: _objectSpreadProps(_objectSpread({}, fetchOptions), {
                    headers: _objectSpreadProps(_objectSpread({}, fetchOptions.headers), {
                        Authorization: authState.token
                    })
                })
            }));
        },
        willAuthError: function(param) {
            var authState = param.authState;
            if (!authState) return true;
            if (authState.token) {
                // simplified version of CognitoUserSession and CognitoJwtToken logic
                // transform now to the same format as the jwt token time properties
                var now = Math.floor(new Date().getTime() / 1000);
                var decoded = (0, _jwtDecode.default)(authState.token);
                // this is called a clock drift, as opposed to CognitoUserSession we don't care about both idToken and accessToken
                // we currently use only idTokens, while the move to using accessTokens instead would need no changes in this area
                var adjusted = now - decoded.iat;
                //is expired ?
                return adjusted < decoded.exp;
            }
            return false;
        },
        didAuthError: function(param) {
            var error = param.error;
            return error.graphQLErrors.some(function(e) {
                var _e_originalError;
                return ((_e_originalError = e.originalError) === null || _e_originalError === void 0 ? void 0 : _e_originalError.errorType) === "UnauthorizedException";
            });
        },
        getAuth: function() {
            var _ref = _asyncToGenerator(function(param) {
                var authState, _ref, token, refreshToken, _ref1, token1, refreshToken1;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            authState = param.authState;
                            if (!!authState) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                authCallbacks.getAuth()
                            ];
                        case 1:
                            _ref = _state.sent() || {}, token = _ref.token, refreshToken = _ref.refreshToken;
                            if (token && refreshToken) {
                                return [
                                    2,
                                    {
                                        token: token,
                                        refreshToken: refreshToken
                                    }
                                ];
                            }
                            return [
                                2,
                                null
                            ];
                        case 2:
                            return [
                                4,
                                authCallbacks.getNewToken()
                            ];
                        case 3:
                            _ref1 = _state.sent() || {}, token1 = _ref1.token, refreshToken1 = _ref1.refreshToken;
                            if (token1 && refreshToken1) {
                                return [
                                    2,
                                    {
                                        token: token1,
                                        refreshToken: refreshToken1
                                    }
                                ];
                            }
                            // otherwise, if refresh fails, log clear storage and log out
                            return [
                                4,
                                authCallbacks.logout()
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    });
};

//# sourceMappingURL=auth.js.map